import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FieldWrapper, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';

interface AlertProps extends FormlyFieldProps {
  alert: {
    text: string;
    html: string;
    type: string;
    show: boolean;
  };
}

@Component({
  selector: 'vectronic-formly-alert-wrapper',
  imports: [CommonModule],
  template: `
    @if (props.alert?.show === true) {
      <div class="alert" [ngClass]="'alert-' + (props.alert.type ?? 'info')">
        @if (props.alert.html) {
          <div [innerHTML]="props.alert.html"></div>
        } @else {
          <p>{{ props.alert.text }}</p>
        }
      </div>
    }
    <ng-template #fieldComponent />
  `,
})
export class AlertWrapperComponent extends FieldWrapper<FormlyFieldConfig<AlertProps>> {}
